module.exports = __webpack_public_path__ + "static/img/no5.1761d1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no5.png
// module id = 7WYS
// module chunks = 31